module Nobox {
    @Serenity.Decorators.registerClass('Serenity.NoboxEntityGrid')
    export class NoboxEntityGrid<TItem, TOptions> extends Serenity.DataGrid<TItem, TOptions> {

        private defaultSetting: Serenity.PersistedGridSettings;
        private WARNING_THRESHOLD = 5;
        private ALERT_THRESHOLD = 3;
        private TIME_LIMIT = 10;
        private timePassed = 0;
        private timeLeft = this.TIME_LIMIT;
        private timerInterval = null;
        private refreshInterval = null;
        private timerActive = false;

        private COLOR_CODES = {
            info: {
                color: "green"
            },
            warning: {
                color: "orange",
                threshold: this.WARNING_THRESHOLD
            },
            alert: {
                color: "red",
                threshold: this.ALERT_THRESHOLD
            }
        };
        constructor(container: JQuery, options?: TOptions) {
            super(container, options);

            this.element.addClass('route-handler')
                .on('handleroute.' + this.uniqueName, (e: JQueryEventObject, arg: any) => {
                    if (!!arg.handled)
                        return;

                    if (!!(arg.route === 'new')) {
                        arg.handled = true;
                        this.addButtonClick();
                        return;
                    }

                    var parts = arg.route.split('/');
                    if (!!(parts.length === 2 && parts[0] === 'edit')) {
                        arg.handled = true;
                        this.editItem(parts[1]);
                        return;
                    }

                    if (!!(parts.length === 2 && parts[1] === 'new')) {
                        arg.handled = true;
                        this.editItemOfType(Q.cast(parts[0], String), null);
                        return;
                    }

                    if (!!(parts.length === 3 && parts[1] === 'edit')) {
                        arg.handled = true;
                        this.editItemOfType(Q.cast(parts[0], String), parts[2]);
                    }
                });
            if (!this.disableHelp()) {
                this.element.find(".grid-title").css("justify-content", "space-between");
                this.element.find('.grid-title').append(`<a style="border-radius: 4px;border: 1px solid var(--s-tool-border);margin-left:5px;" class="btn btn-icon btn-sm p-0 ml-1 float-right" target="_blank" href="${this.HelpLink()}">
                <div class="tool-button icon-tool-button" title="Help">
                    <div class="button-outer">
                        <span class="button-inner green">
                            <i class="fa fa-question-circle text-blue"></i>
                        </span>
                    </div>
                </div>
            </a>`);
            }

            if ($(document).width() < 576) {
                this.element.find(".quick-filters-bar").hide();
            }
        }

        protected HelpLink(): string {
            return $('#GridDiv').attr('help-url');
        }

        protected disableHelp(): boolean {
            return false;
        }

        protected usePager(): boolean {
            return true;
        }
        createToolbar(btns: Serenity.ToolButton[]) {
            var $this = this;
            var buttons = [];
            btns.forEach(x => {
                if (x.title) {
                    x.title = this.getButtonTitle(x.title);
                }
                buttons.push(x);
            })
            if ($(document).width() < 576) {
                buttons.push({
                    icon: "fa-caret-down",
                    title: "Filter",
                    cssClass: "btn-filter",
                    separator: true,
                    onClick: function () {
                        $this.element.find(".quick-filters-bar").slideToggle(500, function () {
                            if ($this.element.find(".quick-filters-bar").is(":visible")) {
                                $(".btn-filter").find(".fa").removeClass("fa-caret-down");
                                $(".btn-filter").find(".fa").addClass("fa-caret-up");
                            } else {
                                $(".btn-filter").find(".fa").removeClass("fa-caret-up");
                                $(".btn-filter").find(".fa").addClass("fa-caret-down");
                            }
                        });
                    }
                });
            }
            super.createToolbar(buttons);
        }
        protected getQuickFilters() {
            var quickFilter = super.getQuickFilters();
            if (quickFilter == null || quickFilter.length == 0) {
                this.element.find(".btn-filter").hide();
            }
            quickFilter.forEach((qf, i) => {
                if (qf.type == CustomDateFilter) {
                    var filter3 = quickFilter[i];
                    filter3.handler = h => {
                        const request = (h.request as Serenity.ListRequest);
                        const start = (h.widget as CustomDateFilter).get_value();
                        const end = (h.widget as CustomDateFilter).end_get_value();
                        if (h.active) {
                            if (start != null && end != null) {
                                request.Criteria = [[[qf.field], ">=", start], "and", [[qf.field], "<=", end]]
                            } else if (start != null) {
                                request.Criteria = [[qf.field], ">=", start];
                            } else if (end != null) {
                                request.Criteria = [[qf.field], "<=", end];
                            }
                            h.handled = true;
                        } else {
                            h.handled = true;
                        }
                    };
                }
            });
            return quickFilter;
        }
        protected createToolbarExtensions(): void {
            this.createIncludeDeletedButton();
            this.createQuickSearchInput();
        }

        protected getInitialTitle(): string {
            return this.getDisplayName();
        }

        protected getLocalTextPrefix(): string {
            var result = super.getLocalTextPrefix();

            if (Q.isEmptyOrNull(result)) {
                return this.getEntityType();
            }

            return result;
        }

        private entityType: string;

        protected getEntityType(): string {
            if (this.entityType != null)
                return this.entityType;

            var attr = this.attrs(Serenity.EntityTypeAttribute);

            if (attr.length === 1) {
                return (this.entityType = attr[0].value);
            }

            var name = Q.getTypeFullName(Q.getInstanceType(this));

            var px = name.indexOf('.');
            if (px >= 0) {
                name = name.substring(px + 1);
            }

            if (Q.endsWith(name, 'Grid')) {
                name = name.substr(0, name.length - 4);
            }
            else if (Q.endsWith(name, 'SubGrid')) {
                name = name.substr(0, name.length - 7);
            }

            this.entityType = name;

            return this.entityType;
        }

        private displayName: string;

        protected getDisplayName(): string {
            if (this.displayName != null)
                return this.displayName;

            var attr = this.attrs(Serenity.DisplayNameAttribute);
            if (attr.length >= 1) {
                this.displayName = attr[0].displayName;
                this.displayName = Q.LT.getDefault(this.displayName, this.displayName);
            }
            else {
                this.displayName = Q.tryGetText(this.getLocalTextDbPrefix() + 'EntityPlural');
                if (this.displayName == null)
                    this.displayName = this.getEntityType();
            }

            return this.displayName;
        }

        private itemName: string;

        protected getItemName(): string {
            if (this.itemName != null)
                return this.itemName;

            var attr = this.attrs(Serenity.ItemNameAttribute);
            if (attr.length >= 1) {
                this.itemName = attr[0].value;
                this.itemName = Q.LT.getDefault(this.itemName, this.itemName);
            }
            else {
                this.itemName = Q.tryGetText(this.getLocalTextDbPrefix() + 'EntitySingular');
                if (this.itemName == null)
                    this.itemName = this.getEntityType();
            }

            return this.itemName;
        }

        protected getAddButtonCaption(): string {
            return Q.format(Q.text('Controls.EntityGrid.NewButton'), this.getItemName());
        }

        protected calculateTimeFraction() {
            const rawTimeFraction = this.timeLeft / this.TIME_LIMIT;
            return rawTimeFraction - (1 / this.TIME_LIMIT) * (1 - rawTimeFraction);
        }

        protected onTimesUp(e) {
            clearInterval(this.timerInterval);
            if (this.refreshInterval != null) {
                clearInterval(this.refreshInterval);
            }
            e.html("<i class=\"fa fa-stopwatch text-blue\"></i>");
            this.WARNING_THRESHOLD = 5;
            this.ALERT_THRESHOLD = 3;
            this.TIME_LIMIT = 10;
            this.timePassed = 0;
            this.timeLeft = 10;
            this.timerInterval = null;
            this.refreshInterval = null;
            this.timerActive = false;
        }

        protected startTimer(e) {
            this.timerActive = true;
            var $this = this;
            this.refreshInterval = setInterval(() => {
                this.refresh();
            }, 10000);
            e.removeClass(this.COLOR_CODES.info.color);
            e.removeClass(this.COLOR_CODES.alert.color);
            e.removeClass(this.COLOR_CODES.warning.color);
            e.addClass(this.COLOR_CODES.info.color);
            this.timerInterval = setInterval(() => {
                this.timePassed = this.timePassed += 1;
                this.timeLeft = this.TIME_LIMIT - this.timePassed;
                e.text(this.formatTime(
                    this.timeLeft
                ));
                this.setRemainingPathColor(this.timeLeft, e);

                if (this.timeLeft === 0) {
                    this.WARNING_THRESHOLD = 5;
                    this.ALERT_THRESHOLD = 3;
                    this.TIME_LIMIT = 10;
                    this.timePassed = 0;
                    this.timeLeft = 10;
                }
            }, 1000);
        }
        protected setRemainingPathColor(timeLeft, e) {
            const { alert, warning, info } = this.COLOR_CODES;
            if (timeLeft <= alert.threshold) {
                e
                    .removeClass(warning.color);
                e
                    .addClass(alert.color);
            } else if (timeLeft <= warning.threshold) {
                e
                    .removeClass(info.color);
                e
                    .addClass(warning.color);
            } else if (timeLeft >= warning.threshold) {
                e
                    .removeClass(alert.color);
                e
                    .addClass(info.color);
            }
        }
        protected formatTime(time) {
            let seconds = time % 60;
            let strSec = `${time % 60}`
            if (seconds < 10) {
                strSec = `0${seconds}`;
            }
            if (seconds == 0) {
                strSec = `...`;
            }

            return `${strSec == null ? "" : strSec}`;
        }
        protected getButtonTitle(title: string): string {
            if ($(document).width() < 576) {
                return ``;
            } else {
                return `${title}`;
            }
        }

        protected getButtons(): Serenity.ToolButton[] {
            var $this = this;
            var buttons: Serenity.ToolButton[] = [];
            buttons.push({
                title: this.getButtonTitle(this.getAddButtonCaption()),
                cssClass: 'add-button',
                icon: "fa-plus-circle text-green",
                hotkey: 'alt+n',
                onClick: () => {
                    this.addButtonClick();
                },
                disabled: () => !this.hasInsertPermission() || this.readOnly
            });

            buttons.push(this.newRefreshButton(true));
            var columnPickBtn = Serenity.ColumnPickerDialog.createToolButton(this as any);
            columnPickBtn.icon = "fa-th-list text-blue";
            buttons.push(columnPickBtn);

            buttons.push({
                icon: "fa-undo-alt text-blue",
                hint: "Restore to default grid settings",
                onClick: () => {
                    Q.confirm("Are you sure restore grid settings to default?", () => {
                        this.restoreSettings(this.defaultSetting, this.gridPersistanceFlags())
                        localStorage.removeItem(this.getPersistanceKey());
                        this.refresh();
                        Q.notifySuccess("Restored setting grid to default");
                    });
                }
            });

            buttons.push({
                icon: "fa-stopwatch text-blue",
                separator: true,
                cssClass: "btn-autorefresh",
                hint: "Auto Refresh in 10 seconds",
                onClick: function (e) {
                    if (!$this.timerActive) {
                        if ($(e.currentTarget).hasClass("tool-button")) {
                            $(e.currentTarget).find(".button-inner").text("10");
                            $this.startTimer($(e.currentTarget).find(".button-inner"));
                        } else {
                            $(e.currentTarget).parents(".tool-button").find(".button-inner").text("10")
                            $this.startTimer($(e.currentTarget).parents(".tool-button").find(".button-inner"));
                        }
                    } else {
                        if ($(e.currentTarget).hasClass("tool-button")) {
                            $this.onTimesUp($(e.currentTarget).find(".button-inner"));

                        } else {
                            $this.onTimesUp($(e.currentTarget).parents(".tool-button").find(".button-inner"));
                        }
                    }
                }
            });

            var excelBtn = Serenity.Extensions.ExcelExportHelper.createToolButton({
                grid: this,
                service: Q.resolveUrl(this.getService() + '/ListExcel'),
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            });
            excelBtn.visible = !this.disableExcelButton();
            excelBtn.disabled = this.disableExcelButton();
            buttons.push(excelBtn);

            var pdfButton = Serenity.Extensions.PdfExportHelper.createToolButton({
                grid: this,
                tableOptions: {
                    theme: "grid",
                },
                onViewSubmit: () => this.onViewSubmit()
            });
            pdfButton.visible = !this.disablePdfButton();
            pdfButton.disabled = this.disablePdfButton();
            buttons.push(pdfButton);
            return buttons;
        }

        protected disableExcelButton(): boolean {
            return false;
        }

        protected disablePdfButton(): boolean {
            return false;
        }

        protected newRefreshButton(noText?: boolean): Serenity.ToolButton {
            return {
                title: (noText ? null : Q.text('Controls.EntityGrid.RefreshButton')),
                hint: (noText ? Q.text('Controls.EntityGrid.RefreshButton') : null),
                cssClass: 'refresh-button',
                icon: "fa-refresh text-blue",
                onClick: () => {
                    this.refresh();
                }
            };
        }

        protected addButtonClick(): void {
            this.editItem(new Object());
        }

        protected editItem(entityOrId: any): void {
            this.createEntityDialog(this.getItemType(), dlg => {
                var dialog = Q.safeCast(dlg, Serenity.IEditDialog);
                if (dialog != null) {
                    dialog.load(entityOrId, () => {
                        dialog.dialogOpen(this.openDialogsAsPanel);
                    });

                    return;
                }

                throw new Error(
                    Q.format("{0} doesn't implement IEditDialog!",
                        Q.getTypeFullName(Q.getInstanceType(dlg))));
            });
        }

        protected editItemOfType(itemType: string, entityOrId: any): void {

            if (itemType === this.getItemType()) {
                this.editItem(entityOrId);
                return;
            }

            this.createEntityDialog(itemType, dlg => {
                var dialog = Q.safeCast(dlg, Serenity.IEditDialog);
                if (dialog != null) {
                    dialog.load(entityOrId, () =>
                        dialog.dialogOpen(this.openDialogsAsPanel));
                    return;
                }

                throw new Error(
                    Q.format("{0} doesn't implement IEditDialog!",
                        Q.getTypeFullName(Q.getInstanceType(dlg))));
            });
        }

        private service: string;

        protected getService(): string {
            if (this.service != null)
                return this.service;

            var attr = this.attrs(Serenity.ServiceAttribute);
            if (attr.length >= 1)
                this.service = attr[0].value;
            else
                this.service = Q.replaceAll(this.getEntityType(), '.', '/');

            return this.service;
        }

        protected getViewOptions(): Slick.RemoteViewOptions {
            var opt = super.getViewOptions();
            opt.rowsPerPage = 20;
            opt.url = Q.resolveUrl('~/Services/' + this.getService() + '/List');
            return opt;
        }
        protected getPagerOptions() {
            let opt = super.getPagerOptions();
            opt.rowsPerPageOptions = [10, 20, 50, 100, 500, 1000];
            return opt;
        }

        protected getItemType() {
            return this.getEntityType();
        }

        protected routeDialog(itemType: string, dialog: Serenity.Widget<any>) {
            Q.Router && Q.Router.dialog && Q.Router.dialog(this.element, dialog.element, () => {
                var hash = '';

                if (itemType !== this.getItemType())
                    hash = itemType + '/';

                if (!!(dialog != null && (dialog as any).entityId != null))
                    hash += 'edit/' + (dialog as any).entityId.toString();
                else
                    hash += 'new';

                return hash;
            });
        }

        protected getInsertPermission(): string {
            return null;
        }

        protected hasInsertPermission(): boolean {
            var insertPermission = this.getInsertPermission();
            return insertPermission == null || Q.Authorization.hasPermission(this.getInsertPermission());
        }

        protected transferDialogReadOnly(dialog: Serenity.Widget<any>) {
            if (this.readOnly)
                Serenity.EditorUtils.setReadOnly(dialog, true);
        }

        protected initDialog(dialog: Serenity.Widget<any>): void {
            Serenity.SubDialogHelper.bindToDataChange(dialog, this, (e, dci) => {
                this.subDialogDataChange();
            }, true);

            this.transferDialogReadOnly(dialog);
            this.routeDialog(this.getItemType(), dialog);
        }

        protected initEntityDialog(itemType: string, dialog: Serenity.Widget<any>): void {
            if (itemType === this.getItemType()) {
                this.initDialog(dialog);
                return;
            }

            Serenity.SubDialogHelper.bindToDataChange(dialog, this, (e, dci) => {
                this.subDialogDataChange();
            }, true);

            this.transferDialogReadOnly(dialog);
            this.routeDialog(itemType, dialog);
        }

        protected createEntityDialog(itemType: string, callback?: (dlg: Serenity.Widget<any>) => void): Serenity.Widget<any> {
            var dialogClass = this.getDialogTypeFor(itemType);
            var dialog = Serenity.Widget.create({
                type: dialogClass,
                options: this.getDialogOptionsFor(itemType),
                init: d => {
                    this.initEntityDialog(itemType, d);
                    callback && callback(d);
                }
            });

            return dialog;
        }

        protected getDialogOptions(): JQueryUI.DialogOptions {
            return {};
        }

        protected getDialogOptionsFor(itemType: string): JQueryUI.DialogOptions {
            if (itemType === this.getItemType())
                return this.getDialogOptions();

            return {};
        }

        protected getDialogTypeFor(itemType: string): { new(...args: any[]): Serenity.Widget<any> } {

            if (itemType === this.getItemType()) {
                return this.getDialogType();
            }

            return Serenity.DialogTypeRegistry.get(itemType) as any;
        }

        private dialogType: Serenity.WidgetDialogClass;

        protected getDialogType(): { new(...args: any[]): Serenity.Widget<any> } {

            if (this.dialogType != null)
                return this.dialogType;

            var attr = this.attrs(Serenity.DialogTypeAttribute);
            if (attr.length >= 1)
                this.dialogType = attr[0].value;
            else
                this.dialogType = Serenity.DialogTypeRegistry.get(this.getEntityType());

            return this.dialogType;
        }

        protected getColumns() {
            var columns = super.getColumns();
            columns.forEach((x, i) => {
                if (x.sourceItem.quickFilter) {
                    //if (x.sourceItem.editorType == "Nobox.CustomDateFilter") {
                    //}

                    var type = x.sourceItem.editorType;
                    if (type == undefined) {
                        type = `Serenity.${x.sourceItem.filteringType}Editor`;
                    } else if (Q.getType(type) == null) {
                        type = `Serenity.${x.sourceItem.editorType}Editor`;
                    }
                    const formater = columns[i].format;
                    if (formater) {
                        columns[i].format = (ctx) => `<a href="javascript:;" class="form-${type}${x.field}">${formater(ctx)}</a>`;
                    } else {

                        columns[i].format = (ctx) => {
                            if (Q.isEmptyOrNull(ctx.value)) {
                                return '';
                            } else {
                                return `<a href="javascript:;" class="form-${type}${x.field}">${ctx.value}</a>`;
                            }
                        };
                    }
                }
            })
            return columns;
        }

        protected getFilter() {
            var columns = super.getColumns();
            var arrResult = [];
            if (columns != null) {
                columns.forEach((x, i) => {
                    if (x.sourceItem.quickFilter) {

                        var type = x.sourceItem.editorType;
                        if (type == undefined) {
                            type = `Serenity.${x.sourceItem.filteringType}Editor`;
                        } else if (Q.getType(type) == null) {
                            type = `Serenity.${x.sourceItem.editorType}Editor`;
                        }
                        var filterId = x.sourceItem.filteringIdField;
                        if (filterId == undefined) {
                            filterId = x.sourceItem.name;
                        }
                        arrResult.push({
                            filterId: filterId,
                            type: type,
                            field: x.field,
                            name: x.name
                        })
                    }
                })
            }
            return arrResult;
        }

        protected onClick(e, row, cell) {
            super.onClick(e, row, cell);
            if (e.isDefaultPrevented()) {
                return;
            }

            var item = this.itemAt(row);
            var target = $(e.target);
            var arrFilter = this.getFilter();
            arrFilter.forEach(x => {
                if (target.hasClass(`form-${x.type}${x.field}`)) {
                    e.preventDefault();

                    Q.notifySuccess(`Success filter by ${x.name}`);
                    var formFilterDt = this.findQuickFilter(Q.getType(`${x.type}`) as any,
                        x.filterId);
                    formFilterDt.set_value(item[x.filterId].toString());
                    this.refresh();
                } else if (target.parent().hasClass(`form-${x.type}${x.field}`)) {
                    e.preventDefault();

                    Q.notifySuccess(`Success filter by ${x.name}`);
                    var formFilterDt = this.findQuickFilter(Q.getType(`${x.type}`) as any,
                        x.filterId);
                    formFilterDt.set_value(item[x.filterId].toString());
                    this.refresh();
                }
            });
        }

        protected updateInterface() {
            this.defaultSetting = this.getCurrentSettings();
            super.updateInterface();
        }

        protected getPersistanceStorage(): Serenity.SettingStorage {
            return window.localStorage;
        }

        protected getSlickOptions(): Slick.GridOptions {
            var opt = super.getSlickOptions();
            opt.enableTextSelectionOnCells = true;
            opt.selectedCellCssClass = "slick-row-selected";
            opt.enableCellNavigation = true;
            return opt;
        }
    }

}